/**
 * Reducer function that returns latest release for each Serial Number and Product Line Combination.
 * Example: productList.reduce(latestProdReleaseBySerialNumberReducer, {})
 * @param uniqueProdMap
 * @param currProd
 * @param index
 * @param array
 * @returns {*}
 */

 const latestProdReleaseBySerialNumberReducer = (uniqueProdMap, currProd, index, array) => {
  let uniqueProdMapObj = uniqueProdMap;
  if(array.length === 0 ){
    return [];
  }

  if (typeof uniqueProdMapObj === 'object' && currProd.serialNumber !== undefined
    && currProd.productLineCode !== undefined && currProd.release) {
    const hashKey = currProd.serialNumber + currProd.productLineCode
    if (uniqueProdMapObj[hashKey] !== undefined) {
      /**
       * if the product is already in the map then check if it is latest release.
       * if the current product is the latest the update the map the latest release.
       */
      if (uniqueProdMapObj[hashKey].release < currProd.release) {
        uniqueProdMapObj[hashKey] = currProd
      }
    } else {
      uniqueProdMapObj[hashKey] = currProd
    }
  } else {
    // If the initial value is not passed then set it to empty object.
    uniqueProdMapObj = {}
  }
  // Return as Product List finally
  if (index === array.length - 1) {

    return Object.keys(uniqueProdMapObj).map(e => uniqueProdMapObj[e]) // return the non products with the latest release per SN+PLC
  } 
  return uniqueProdMapObj;
}

export default latestProdReleaseBySerialNumberReducer;